module.exports = "/images/Theme Park.svg?5d7a8bff131dba8c11c69febb7cd3058";